var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sort"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.16656 9.16665H15.1668C15.2656 9.16662 15.3623 9.13551 15.4445 9.07724C15.5267 9.01897 15.5908 8.93615 15.6286 8.83927C15.6664 8.74238 15.6763 8.63577 15.6571 8.53292C15.6378 8.43007 15.5902 8.33559 15.5203 8.26142L11.0202 3.48871C10.9738 3.43945 10.9186 3.40037 10.858 3.3737C10.7973 3.34704 10.7323 3.33331 10.6667 3.33331C10.601 3.33331 10.536 3.34704 10.4753 3.3737C10.4147 3.40037 10.3596 3.43945 10.3131 3.48871L5.81305 8.26142C5.74315 8.33559 5.69554 8.43007 5.67626 8.53292C5.65697 8.63577 5.66688 8.74238 5.70471 8.83927C5.74255 8.93615 5.80662 9.01897 5.88883 9.07724C5.97103 9.13551 6.06768 9.16662 6.16656 9.16665Z",
    fill: "#88C3E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1668 10.8333H6.16656C6.06768 10.8333 5.97103 10.8644 5.88883 10.9227C5.80662 10.981 5.74255 11.0638 5.70471 11.1607C5.66688 11.2576 5.65697 11.3642 5.67626 11.467C5.69554 11.5699 5.74315 11.6644 5.81305 11.7385L10.3131 16.5113C10.3596 16.5605 10.4147 16.5996 10.4753 16.6263C10.536 16.6529 10.601 16.6666 10.6667 16.6666C10.7323 16.6666 10.7973 16.6529 10.858 16.6263C10.9186 16.5996 10.9738 16.5605 11.0202 16.5113L15.5203 11.7385C15.5902 11.6644 15.6378 11.5699 15.6571 11.467C15.6763 11.3642 15.6664 11.2576 15.6286 11.1607C15.5908 11.0638 15.5267 10.981 15.4445 10.9227C15.3623 10.8644 15.2656 10.8333 15.1668 10.8333Z",
    fill: "#88C3E1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortSvg);
export default __webpack_public_path__ + "static/media/SortSvg.4c3a2268df7cd915fc00645cf4b583b7.svg";
export { ForwardRef as ReactComponent };